<script>
import emailLayoutForm from "@/views/menu/configurations/emails/layouts/emailLayoutForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    emailService: "emailService",
    toastService: "toastService"
  },
})
export default class EmailLayoutEdit extends mixins(emailLayoutForm) {
  formId = "edit-email-layout-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save,
      },
    ];
  }

  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
        await this.emailService.updateLayout(this.$route.params.id, this.model);
      this.$router.push("/configurations/emails/list/layouts");
      this.toastService.success(this.translations.success.emailLayout_update);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.emailLayouts_edit;
  }

  async afterCreate() {
    this.model = await this.emailService.readLayout(this.$route.params.id);
    this.isReady = true;
  }
}
</script>
